import type { App } from 'vue';
export interface TouchVueUIOptions {
    ratio?: {
        base?: {
            pc?: number;
            pad?: number;
            phone?: number;
        };
    };
    zIndex?: number;
    input?: {
        spChars?: string;
    };
    lang?: string;
}
export declare const defaultOptions: TouchVueUIOptions;
export declare let globalOptions: {
    ratio?: {
        base?: {
            pc?: number;
            pad?: number;
            phone?: number;
        };
    };
    zIndex?: number;
    input?: {
        spChars?: string;
    };
    lang?: string;
};
export declare const getGlobalOptions: () => TouchVueUIOptions;
declare const install: (app: App, options?: TouchVueUIOptions) => void;
export default install;
export * from '@touchvue/components';
export * from '@touchvue/directives';
export * from '@touchvue/locale';
export * from '@touchvue/utils';
export * from '@touchvue/hooks';
